var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 19.25V2.75C31 1.22833 29.779 0 28.2663 0H2.73369C1.22105 0 0 1.22833 0 2.75V19.25C0 20.7717 1.22105 22 2.73369 22H28.2663C29.779 22 31 20.7717 31 19.25ZM28.6126 2.54833C29.214 3.15333 28.8859 3.77667 28.5579 4.08833L21.1587 10.9083L28.2663 18.3517C28.485 18.6083 28.6308 19.0117 28.3757 19.2867C28.1387 19.58 27.592 19.5617 27.3551 19.3783L19.3909 12.54L15.4909 16.115L11.6091 12.54L3.64491 19.3783C3.408 19.5617 2.86126 19.58 2.62434 19.2867C2.36919 19.0117 2.51499 18.6083 2.73369 18.3517L9.84127 10.9083L2.44209 4.08833C2.11405 3.77667 1.78601 3.15333 2.38742 2.54833C2.98883 1.94333 3.60847 2.23667 4.11875 2.67667L15.4909 11.9167L26.8812 2.67667C27.3915 2.23667 28.0112 1.94333 28.6126 2.54833Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.5e4f1409.svg";
export { ForwardRef as ReactComponent };